import { Button, Col, Icon, Input, Progress, Row, Modal, Carousel } from 'antd';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import lang from './../../../languages/en';
import logo from './../../../resources/assets/images/logo.png';
import avatar from './../../../resources/assets/images/user-black.png';
import handleException from './../../../services/handleException';
import history from './../../../services/history';
import { alertError, destroyMessage } from './../../../services/dialog';
import Preload from './../../../services/Preload';
import { validateEmail } from './../../../services/ruleValidate';
import Storage from './../../../services/Storage';
import { getNews, getBanners, login } from './../../../utils/login';
import './styles.css';
import { titleHead } from './../../../services/helper';
import handlePermission from './../../app/handlePermission';
import { permissions, FulfillOption } from './../../../constants'
import Cookies from 'js-cookie';
import moment from 'moment';
import MFAVerify from '../mfa-verify';
import MFASetup from '../mfa-setup';

class Login extends Component {
    constructor(props) {
        super(props)
        this.state = {
            inputs: {
                email: '',
                password: '',
            },
            isLoading: false,
            isDisable: false,
            percent: 1,
            listNews: [],
            banners: [],
            message: {},
            error: true,
            showMFAVerify: false,
            mfaToken: null,
            showMFASetup: false
        }

        if (localStorage.getItem('access_token')) {
            this.props.history.push('/orders')
        }
    }

    onChange = (e, column) => {
        let val = e.target.value
        this.setState({
            inputs: {
                ...this.state.inputs,
                [column]: val,
            },
        })
        return val
    }

    componentDidMount() {
        titleHead("Login")
        getNews().then(res => {
            if (res && res.data.code === 10001) {
                this.setState({
                    listNews: res.data.data.Items
                })
            } else {
                handleException(res)
            }
        }).catch(err => {
            handleException(err)
        })

        getBanners().then(res => {
            if (res && res.data.code === 10001) {
                this.setState({
                    banners: res.data.data.Banners
                })
            } else {
                handleException(res)
            }
        }).catch(err => {
            handleException(err)
        })

    }

    checkButtonSubmit = () => {
        const { email, password } = this.state.inputs;
        if (!email || !password) return true
        return false;
    }

    runningLoading = () => {
        this.runProgress = setInterval(() => {
            if (this.state.percent < 70) {
                this.setState({
                    percent: this.state.percent + Math.round(Math.random() * 15),
                })
            } else if (this.state.percent < 95) {
                this.setState({
                    percent: this.state.percent + 1,
                })
            } else {
                clearInterval(this.runProgress)
            }
        }, 300)
    }

    componentWillUnmount = () => {
        // Clear any pending timeouts or intervals
        if (this.runProgress) {
            clearInterval(this.runProgress);
        }
        // Clear any pending state updates
        this.setState = () => {};
    };

    loggedText = (percent) => {
        if (percent === 100) {
            return <Icon type="check" />;
        } else {
            return "Logging in";
        }
    }

    renderListNews = () => {
        return this.state.listNews.map((e, i) => {
            return (
                <tr className="item" key={i}>
                    <td className="date">
                        <span className="time">{e.Date}</span>
                    </td>
                    <td className='title-news-login'>
                        <span dangerouslySetInnerHTML={{ __html: e.Title }} />
                    </td>
                </tr>
            )
        })
    }

    renderBanner = () => {
        var now = moment();

        var showBanners = this.state.banners
            .filter((b, i) => {
                var showFromD = moment(b.StartDate, "MM/DD/YYYY");
                var showEndD = moment(b.EndDate, 'MM/DD/YYYY');

                return now.isBetween(showFromD, showEndD);
            })
            .sort((a, b) => moment(a.StartDate, "MM/DD/YYYY") - moment(b.StartDate, "MM/DD/YYYY"));

        // add space
        if (showBanners.length == 0) {
            showBanners.push({});
        }

        return (
            <div style={{ backgroundColor: "#f8f8f8" }}>
                <Carousel className="div-login-banners" autoplay>
                    {showBanners.map((b, i) => {
                        return (
                            <div key={i} >
                                {b.Url ? <img className='banner' src={b.Url} alt={b.Name ? b.Name : ''} onClick={(e) => {
                                    if (b.Link) {
                                        window.open(b.Link, '_blank');
                                    }
                                }} /> : <div className='banner' />}
                            </div>
                        )
                    })}
                </Carousel>
            </div>
        )
    }

    onChange = (value, name) => {
        this.validate(value, name)
        this.setState({
            inputs: {
                ...this.state.inputs,
                [name]: value
            }
        })
    }

    validate = (value, name) => {
        let message = {}

        if (!value && name === 'email') {
            message = {
                name: name,
                value: lang.email_address_null,
            }
        }
        if (!value && name === 'password') {
            message = {
                name: name,
                value: lang.password_null
            }
        }

        this.setState({
            message
        })
    }

    submit = (e) => {
        e.preventDefault()
        const { email } = this.state.inputs;
        let message = {}

        if (!validateEmail(email)) {
            message = {
                name: 'email',
                value: lang.email_invalid
            }
            this.setState({
                message,
                error: true
            })
            return;
        }

        this.setState({
            isLoading: true,
        }, () => {
            let data = {
                username: this.state.inputs.email.trim(),
                password: this.state.inputs.password,
                grant_type: 'password',
            }
            this.runningLoading()

            login(data).then(res => {
                if (res.data.code === '1' && res.data.access_token) {
                    // Store user data temporarily

                    const userData = {
                        'first_name': res.data.user_first_name,
                        'last_name': res.data.user_last_name,
                        'company': res.data.user_company,
                        'user_name': res.data.user_name,
                        'permissions': res.data.permissions,
                        'TwoFactorEnabled': res.data.TwoFactorEnabled == 'True' ? true : false,
                        'MFAConfigured': res.data.MFAConfigured == 'True' ? true : false,
                        'AuthenticatorKey': res.data.AuthenticatorKey ? true : false
                    };

                    // Store temporary data for MFA process
                    Storage.set('temp_user', userData);
                    localStorage.setItem('temp_token', res.data.access_token);

                    // Check if MFA is enabled for the user
                    if (userData.TwoFactorEnabled) {
                        if (!userData.MFAConfigured) {
                            // Show MFA setup if not configured
                            this.setState({
                                showMFASetup: true,
                                isLoading: false
                            });
                        } else {
                            // Show MFA verification if already configured
                            this.setState({
                                showMFAVerify: true,
                                mfaToken: res.data.access_token,
                                isLoading: false
                            });
                        }
                        return;
                    }

                    // If MFA is not enabled, proceed with normal login
                    this.completeLogin(res.data);
                } else {
                    handleException(res);
                    this.setState({
                        isLoading: false
                    });
                }
            }).catch(err => {
                if(err.response){
                  switch (err.response.data.error){
                    case 'account_locked':
                      alertError(lang.account_locked, lang.account_locked_line2)
                      break;
                    case 'invalid_username_or_password':
                      message = {
                        name: 'error',
                        value: lang.invalid_username_password
                      }
                      break;
                    default:
                      alertError(lang.unknow_error)
                      break;
                  }
                }
                this.setState({
                  isLoading:false,
                  error:true,
                  message
                })
            });
        });
    }

    completeLogin = (data) => {
        Storage.set('user', {
            'first_name': data.user_first_name,
            'last_name': data.user_last_name,
            'company': data.user_company,
            'user_name': data.user_name,
            'permissions': data.permissions,
            'TwoFactorEnabled': data.TwoFactorEnabled || false
        });
        localStorage.setItem('access_token', data.access_token);
        localStorage.setItem(
            'time_expired',
            (Date.now() + parseInt(process.env.REACT_APP_TIME_OUT_CLIENT)).toString()
        );

        Preload.execute(data.access_token).then(resPayload => {
            destroyMessage();
            this.setState({
                percent: 100
            }, () => {
                setTimeout(() => {
                    this.setState({
                        isLoading: false,
                        error: false
                    });
                    history.push('/orders');
                }, 500);
            });
        });
    }

    handleMFASetupSuccess = () => {
        const tempUser = Storage.get('temp_user');
        const tempToken = localStorage.getItem('temp_token');

        this.completeLogin({
            access_token: tempToken,
            user_first_name: tempUser.first_name,
            user_last_name: tempUser.last_name,
            user_company: tempUser.company,
            user_name: tempUser.user_name,
            permissions: tempUser.permissions,
            TwoFactorEnabled: true,
            MFAConfigured: true
        });

        // Clean up temporary data
        Storage.remove('temp_user');
        localStorage.removeItem('temp_token');
    }

    handleMFAVerifySuccess = () => {
        const tempUser = Storage.get('temp_user');
        const tempToken = localStorage.getItem('temp_token');

        this.completeLogin({
            access_token: tempToken,
            user_first_name: tempUser.first_name,
            user_last_name: tempUser.last_name,
            user_company: tempUser.company,
            user_name: tempUser.user_name,
            permissions: tempUser.permissions,
            TwoFactorEnabled: true,
            MFAConfigured: true
        });

        // Clean up temporary data
        Storage.remove('temp_user');
        localStorage.removeItem('temp_token');
    }

    handleMFASetupClose = () => {
        this.setState({
            showMFASetup: false,
            isLoading: false
        });
        // Clean up temporary data
        Storage.remove('temp_user');
        localStorage.removeItem('temp_token');
    }

    handleMFAVerifyClose = () => {
        this.setState({
            showMFAVerify: false,
            isLoading: false
        });
        // Clean up temporary data
        Storage.remove('temp_user');
        localStorage.removeItem('temp_token');
    }

    render() {
        const { inputs } = this.state

        if (this.state.isLoading) {
            return (
                <div
                    style={{
                        display: 'flex',
                        flex: 1,
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100vh'
                    }}
                >
                    <Progress id='loading-progress-login' type="circle" percent={this.state.percent} format={this.loggedText} />
                </div>
            )
        }
        if (this.state.error) {
            clearInterval(this.runProgress)
        }

        return (
            <Fragment>
                <Progress id='loading-progress-login' type="circle" percent={this.state.percent} format={this.loggedText} />
                <div id="login">
                    <Row>
                        <Col xs={24} lg={12} className="left">
                            <Row type="flex" justify="center">
                                <div className="div-login-form">
                                    <div className="wrap-icon">
                                        <div className="img">
                                            <img src={logo} />
                                        </div>
                                    </div>
                                    <div className="wrap-login">
                                        <img className="avatar" src={avatar} />
                                        <form className='login-form' autoComplete="off">
                                            <div className='user-id'>
                                                <Input
                                                    prefix={<Icon className="icon" type="user" />}
                                                    placeholder="User ID"
                                                    autoComplete="off"
                                                    onChange={(e) => this.onChange(e.target.value, 'email')}
                                                    value={inputs.email}
                                                    maxLength={100}
                                                    tabIndex="1"
                                                />
                                                <span className='message'>{this.state.message.name === 'email' ? this.state.message.value : null}</span>
                                            </div>
                                            <div className='password'>
                                                <Input
                                                    prefix={<Icon className="icon" type="lock" />}
                                                    type="password"
                                                    placeholder="Password"
                                                    autoComplete="off"
                                                    onChange={(e) => this.onChange(e.target.value, 'password')}
                                                    value={inputs.password}
                                                    maxLength={32}
                                                    tabIndex="2"
                                                />
                                                <span className='message'>{this.state.message.name === 'password' && this.state.message.value}</span>
                                            </div>
                                            <div className='message-err message'>{this.state.message.name === 'error' && this.state.message.value}</div>
                                            <div className="login-button">
                                                <Button
                                                    type="primary"
                                                    htmlType="submit"
                                                    className="login-form-button"
                                                    disabled={this.checkButtonSubmit()}
                                                    onClick={(e) => this.submit(e)}
                                                >Log In</Button>
                                                <p>
                                                    <Link className="login-form-forgot" to="/forgot-password">Forgot Password?</Link>
                                                </p>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="wrap-text">
                                        Don't have an Account?
                                        <span className='contact-yamato-office-link'>
                                            <a className="location" href="https://www.yamatoamerica.com/locations/" target='_blank'>Contact Yamato.</a>
                                        </span>
                                    </div>
                                    <div className="term-conditions">
                                        <span className='term-conditions-link'>
                                            <Link className="location" to='/terms-and-conditions' target='_blank'>Terms and Conditions</Link>
                                        </span>
                                    </div>
                                    <div>
                                        <span>
                                            <a className="location" href="https://www.yamatoamerica.com/payment-terms/" target='_blank'>Payment Terms & Conditions</a>
                                        </span>
                                    </div>
                                </div>
                            </Row>
                        </Col>
                        <Col xs={24} lg={12}>
                            {this.renderBanner()}
                            <Row type="flex" justify="center" className="right">
                                <div className="div-login-news">
                                    <div className="wrap-header">
                                        <h3>News for everyone</h3>
                                    </div>
                                    <div className="wrap-new news-login">
                                        <table>
                                            <tbody>
                                                {this.renderListNews()}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </Row>
                        </Col>
                    </Row>
                </div>
                <MFASetup
                    visible={this.state.showMFASetup}
                    onClose={this.handleMFASetupClose}
                    onSuccess={this.handleMFASetupSuccess}
                />
                <MFAVerify
                    visible={this.state.showMFAVerify}
                    onClose={this.handleMFAVerifyClose}
                    onSuccess={this.handleMFAVerifySuccess}
                />
            </Fragment>
        );
    }
}


export default Login;



// WEBPACK FOOTER //
// ./src/containers/auth/login/index.js